



















import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class Tab extends Vue {
  @Prop() private tabList!: object[];
  @Prop() private name!: object[];
  @Prop({ default: "default" }) private size: string | undefined;
  @Prop({ default: "line" }) private type: string | undefined;
  private handleClick(val: string) {
    this.$emit("tabs", val);
  }
}
